import { api } from "../scripts/api.js";

const esc = (s) =>
   String(s ?? "").replace(/[&<>"']/g, (c) =>
      ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c])
   );

class AppStudentClasses extends HTMLElement {
   connectedCallback() {
      this.innerHTML = `
         <section id="classes">
            <header class="classes-header">
               <h1>My Classes</h1>
            </header>
            <div class="classes-grid" id="classes-grid"></div>
         </section>
      `;

      this.querySelector("#classes-grid").addEventListener("click", (e) => {
         const card = e.target.closest(".class-card");
         if (!card) return;
         const classId = card.dataset.classId;
         if (classId) location.hash = `student-class-detail/${encodeURIComponent(classId)}`;
      });
   }

   show() {
      if (this.loaded) return;
      this.loaded = true;
      this.render();
   }

   async render() {
      const grid = this.querySelector("#classes-grid");
      grid.innerHTML = `<p class="empty">Loading...</p>`;
      try {
         const res = await api("/me");
         const me = await res.json();
         if (!res.ok || !me.ok) throw new Error("failed");

         const classes = me.classes || [];
         if (!classes.length) {
            grid.innerHTML = `<p class="empty">You're not enrolled in any classes yet.</p>`;
            return;
         }
         grid.innerHTML = classes.map((c, i) => this.renderCard(c, i)).join("");
      } catch {
         grid.innerHTML = `<p class="msg err">Couldn't load your classes.</p>`;
      }
   }

   renderCard(c, i) {
      return `
         <div class="class-card" data-class-id="${c.class_id}" role="button" tabindex="0" style="--i:${i}">
            <div class="class-code">${esc(c.course_code)} · ${esc(c.section)}</div>
            <div class="class-title">${esc(c.title || "")}</div>
            <div class="class-term">${esc(c.term)}</div>
         </div>
      `;
   }
}

customElements.define("app-student-classes", AppStudentClasses);